import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UilabMatCardModule } from '@uilab/ng-mat-components';
import { STYLING_CARD_PREVIEW_BACKGROUND } from '../../../../shared/helpers/styling-card-colors';

@Component({
    selector: 'avd-styling-card-shell',
    standalone: true,
    templateUrl: './styling-card-shell.component.html',
    styleUrls: ['./styling-card-shell.component.scss'],
    imports: [UilabMatCardModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StylingCardShellComponent {
    @Input() label: string = '';
    @Input() inverseMode: boolean = false;

    get previewBackgroundColor(): string {
        return this.inverseMode
            ? STYLING_CARD_PREVIEW_BACKGROUND.inverse
            : STYLING_CARD_PREVIEW_BACKGROUND.default;
    }
}
